type AnalyticsValue = string | number | boolean | null | undefined;

export type AnalyticsParams = Record<string, AnalyticsValue>;

function getGtag():
  | ((command: string, eventOrTarget: string, params?: Record<string, string | number | boolean>) => void)
  | null {
  if (typeof window === "undefined" || typeof window.gtag !== "function") {
    return null;
  }
  return window.gtag;
}

function normalizeParams(params?: AnalyticsParams): Record<string, string | number | boolean> {
  const normalized: Record<string, string | number | boolean> = {};
  if (!params) {
    return normalized;
  }
  for (const [key, value] of Object.entries(params)) {
    if (value === null || value === undefined) {
      continue;
    }
    if (typeof value === "string") {
      const trimmed = value.trim();
      if (!trimmed) {
        continue;
      }
      normalized[key] = trimmed;
      continue;
    }
    normalized[key] = value;
  }
  return normalized;
}

export function trackEvent(eventName: string, params?: AnalyticsParams): void {
  const gtag = getGtag();
  const normalizedEvent = eventName.trim();
  if (!gtag || !normalizedEvent) {
    return;
  }
  gtag("event", normalizedEvent, normalizeParams(params));
}

export function trackPageView(path: string, params?: AnalyticsParams): void {
  const gtag = getGtag();
  if (!gtag) {
    return;
  }
  const pagePath = path.trim() || "/";
  gtag("event", "page_view", {
    page_path: pagePath,
    page_title: document.title || "PantryRx App",
    ...normalizeParams(params),
  });
}

export function setUserProperties(params?: AnalyticsParams): void {
  const gtag = getGtag();
  if (!gtag) {
    return;
  }
  gtag("set", "user_properties", normalizeParams(params));
}
